import { DownloadOutlined, FileDoneOutlined, InboxOutlined } from '@ant-design/icons';
import { message, Modal, Select, UploadProps } from 'antd';
import Dragger from 'antd/es/upload/Dragger';
import { useEffect, useState } from 'react';
import { mapToSelectItems } from '../../../utils/utils';
import { ExamTemplate } from '../../../model/response';
import { findAllExamTemplates } from '../../../service/examTemplateService';

type SelectFileViewProps = {
  onCommitFile: any;
  type?: 'exam' | 'practice';
};

export default function SelectFileView({ onCommitFile, type = 'exam' }: SelectFileViewProps) {
  const [fileImport, setFileImport] = useState(null);
  const [examTemplateId, setExamTemplateId] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [examTemplates, setExamTemplates] = useState<ExamTemplate[]>([]);

  useEffect(() => {
    findAllExamTemplates()
      .then((examTemplates) => {
        setExamTemplates(examTemplates);
      })
      .catch((error) => console.error(error));
  }, []);

  const props: UploadProps = {
    name: 'file',
    maxCount: 1,
    action: '',
    accept: '.doc,.docx',
    onChange(info) {
      const { status } = info.file;

      if (status !== 'uploading') {
        info.file.status = 'done';
      }
      setFileImport(info.file?.originFileObj as any);
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    style: {
      backgroundColor: fileImport ? '#E1C5E1' : 'rgba(0, 0, 0, 0.02)',
    },
  };

  const commitFileImport = function () {
    if (!fileImport || !examTemplateId) {
      setIsModalOpen(true);
      return;
    }
    onCommitFile(fileImport, examTemplateId);
  };

  const onChangeExamSubjectType = function (e: any) {
    setExamTemplateId(e);
  };

  const closeDialog = function () {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (fileImport) {
      message.success('Load file thành công.').then();
    }
  }, [fileImport]);

  return (
    <div className="w-ful h-full p-4 bg-white">
      <div className="w-full flex justify-between">
        <div className="text-left text-[23px] font-medium">
          {type === 'exam' ? 'Import đề thi' : 'Import đề tự luyện'}
        </div>
        <div className="flex gap-4">
          <button className="primary px-3 py-1 bg-[#e6f8ff] rounded hover:bg-[#d8f0fa]" onClick={commitFileImport}>
            Import
          </button>
        </div>
      </div>
      <div className="mt-6 flex items-center">
        <div className="flex gap-2 items-center">
          <span>Đề: </span>
          <Select
            onChange={(e) => onChangeExamSubjectType(e)}
            className="w-fit min-w-[200px] max-w-[200px]"
            placeholder="Mẫu đề thi"
            style={{ flex: 1 }}
            defaultValue={examTemplateId}
            options={[
              {
                label: 'Chọn mẫu đề thi',
                value: '',
              },
              ...mapToSelectItems(examTemplates),
            ]}
          />
        </div>
        <div className="text-[#4778e2] text-left cursor-pointer ml-4">
          <DownloadOutlined className="text-[22px]" />
          <span className="pl-3">Tải Đề mẫu</span>
        </div>
      </div>
      <div className="p-4 border-1 border-[#e4e4e4] mt-3 w-[60%] m-auto h-[70%] pb-12">
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">{fileImport ? <FileDoneOutlined /> : <InboxOutlined />}</p>
          <p className="ant-upload-text">
            {fileImport ? 'Chọn hoặc kéo thả file(.doc, .docx) để thay đổi' : 'Chọn hoặc kéo thả file(.doc, .docx)'}
          </p>
        </Dragger>
      </div>

      <Modal open={isModalOpen} onOk={closeDialog} onCancel={closeDialog} footer={[]}>
        <p className="text-center">Vui lòng chọn file và mẫu đề thi.</p>
      </Modal>
    </div>
  );
}
